/**
 * Link
 */
export const GOOGLE_CALENDAR_LINK = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=20201003T040000Z%2F20201003T060000Z&text=Dinda+%26+Indra+Wedding&details=Dinda+%26+Indra+Wedding`;
export const GOOGLE_MAPS_LINK = `https://maps.app.goo.gl/GL8UvLhtKWYpfLMk7`;
export const GOOGLE_MAPS_LINK_H = `https://maps.app.goo.gl/SFwCQLQGHGHMVtDN8`;

/**
 * Wedding time
 */
export const EPOCH_START_EVENT = 1699848000;
export const EPOCH_END_EVENT = 1699894800;
export const UTC_WEDDING_TIME = '2020-10-03:04:00:00Z';
